import moment from "moment";

const getDurationForWindow = window => {
  switch (window) {
    case "D":
      return moment.duration(1, "days");
    case "W":
      return moment.duration(1, "weeks");
    case "M":
      return moment.duration(1, "months");
    case "Y":
      return moment.duration(1, "years");
    default:
      throw new Error(`unknown window: ${window}`);
  }
};

const getDateRangeFromDateAndWindow = (date, window) => {
  const duration = getDurationForWindow(window);

  if (duration.asDays() <= 1) {
    return {
      from: moment(date)
        .startOf("day")
        .toDate(),
      to: moment(date)
        .endOf("day")
        .toDate()
    };
  }

  const to = moment(date)
    .endOf("day")
    .toDate();

  let from = moment(to)
    .subtract(duration)
    .startOf("day")
    .toDate();

  if (window === "M") {
    from = moment(from)
      .startOf("month")
      .startOf("day")
      .toDate();
  }

  return {
    from,
    to
  };
};

const getNextWindow = (currentWindow, window) => {
  const duration = getDurationForWindow(window);

  const from = moment(currentWindow.from)
    .add(duration)
    .toDate();

  const to = moment(currentWindow.to)
    .add(duration)
    .toDate();

  return { from, to };
};

const getPreviousWindow = (currentWindow, window) => {
  const duration = getDurationForWindow(window);

  const from = moment(currentWindow.from)
    .subtract(duration)
    .toDate();

  const to = moment(currentWindow.to)
    .subtract(duration)
    .toDate();

  return { from, to };
};

const isDateAfterToday = date =>
  date >
  moment()
    .endOf("day")
    .toDate();

const isKnownWindow = window => {
  switch (window) {
    case "D":
    case "W":
    case "M":
    case "Y":
      return true;
    default:
      return false;
  }
};

const isDateAfterEndDate = (date, endDate) =>
  date >
  moment(endDate)
    .endOf("day")
    .toDate();

export {
  getDurationForWindow,
  getDateRangeFromDateAndWindow,
  getNextWindow,
  getPreviousWindow,
  isDateAfterToday,
  isKnownWindow,
  isDateAfterEndDate
};
